import { createStore } from '~/store/createStore';
export const useSymbolDictionaryStore = createStore((set, get) => {
    return {
        dictionary: {},
    };
});
